// API Configuration
const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000').replace(/\/$/, '');

// ---- Auth token helpers (JWT in Authorization header) ----

export const getAuthToken = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem('authToken');
  } catch {
    return null;
  }
};

export const setAuthToken = (token) => {
  if (typeof window === 'undefined') return;
  try {
    if (token) {
      window.localStorage.setItem('authToken', token);
    } else {
      window.localStorage.removeItem('authToken');
    }
  } catch {
    // ignore storage errors
  }
};

export const clearAuthToken = () => setAuthToken(null);

// Wrapper around fetch that automatically attaches Authorization: Bearer <token>
export const authFetch = (url, options = {}) => {
  const token = getAuthToken();
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  // Keep credentials: 'include' by default so localhost/cookie flows still work.
  const fetchOptions = {
    credentials: options.credentials ?? 'include',
    ...options,
    headers,
  };
  return fetch(url, fetchOptions);
};

const config = {
  API_URL,
  SOCKET_URL: API_URL,
};

export default config;